
export { useApproveTransactionModal } from "/home/runner/work/capsicum/capsicum/libs/socios-core/shared/wallet-connect/hooks/useApproveTransactionModal.ts"